import axios from "axios";
import Config from "@/config";
import moment from 'moment';

const getInterval = function(startDateTime, endDateTime) {
  let interval = 120;
  let from = moment(startDateTime);
  let end = moment(endDateTime);
  let diff = end.diff(from, 'days');
  if(diff>7) {
    interval = 14400;
  } else if(diff>1) {
    interval = 3600;
  }
  return interval;
}

const getTolerance = function(startDateTime, endDateTime) {
  let tolerance = 120;
  let from = moment(startDateTime);
  let end = moment(endDateTime);
  let diff = end.diff(from, 'days');
  if(diff>7) {
    tolerance = 1800;
  } else if(diff>1) {
    tolerance = 900;
  }
  return tolerance;
}

export default class AnalyticsService {

  getAllAdminChartsId(accesstoken, serialNumber) {
    const options = {
      headers: {
        ...Config.headers(accesstoken),
        ...{}
      }
    };
    return axios
      .get(
        Config.proxy + Config.url("analytics") + "/" + serialNumber + "/getAdminCharts",
        options
      )
      .then(res => res.data);
  }
  getAdminChartsById(accesstoken, serialNumber, startDateTime, endDateTime, idChart) {
    let tolerance = getTolerance(startDateTime, endDateTime);
    let interval = getInterval(startDateTime, endDateTime);
    const options = {
      headers: {
        ...Config.headers(accesstoken),
        ...{}
      }
    };
    return axios
      .get(
        Config.proxy + Config.url("analytics") + "/" + serialNumber + "/getAdminCharts/" + idChart + "?startDate=" + startDateTime + "&endDate=" + endDateTime + "&interval=" + interval + "&tolerance=" + tolerance,
        options
      )
      .then(res => res.data);
  }
  getAllServiceChartsId(accesstoken, serialNumber) {
    const options = {
      headers: {
        ...Config.headers(accesstoken),
        ...{}
      }
    };
    return axios
      .get(
        Config.proxy + Config.url("analytics") + "/" + serialNumber + "/getServiceCharts",
        options
      )
      .then(res => res.data);
  }
  getServiceChartsById(accesstoken, serialNumber, startDateTime, endDateTime, idChart) {
    let tolerance = getTolerance(startDateTime, endDateTime);
    let interval = getInterval(startDateTime, endDateTime);
    const options = {
      headers: {
        ...Config.headers(accesstoken),
        ...{}
      }
    };
    return axios
      .get(
        Config.proxy + Config.url("analytics") + "/" + serialNumber + "/getServiceCharts/" + idChart + "?startDate=" + startDateTime + "&endDate=" + endDateTime + "&interval=" + interval + "&tolerance=" + tolerance,
        options
      )
      .then(res => res.data);
  }
  getLabChartsId(accesstoken, labId) {
    const options = {
      headers: {
        ...Config.headers(accesstoken),
        ...{}
      }
    };
    return axios
      .get(
        Config.proxy + Config.url("analytics") + "/" + labId + "/getLabCharts",
        options
      )
      .then(res => res.data);
  }
  getLabChartsById(accesstoken, labId, startDateTime, endDateTime, gamma, idChart) {
    let tolerance = getTolerance(startDateTime, endDateTime);
    let interval = getInterval(startDateTime, endDateTime);
    const options = {
      headers: {
        ...Config.headers(accesstoken),
        ...{}
      }
    };
    return axios
      .get(
        Config.proxy + Config.url("analytics") + "/" + labId + "/getLabCharts/" + idChart + "?startDate=" + startDateTime + "&endDate=" + endDateTime + "&gamma=" + gamma + "&interval=" + interval + "&tolerance=" + tolerance,
        options
      )
      .then(res => res.data);
  }
}